import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { PartnerBusinessTypeSchema, UpdatePartnerRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const LEGAL_ENTITY_TYPES = UpdatePartnerRequestSchema.shape.legal_entity_type.unwrap().options

const normalize = fieldNormalizer({
  trimmed: ['name'],
  blankToNull: ['description', 'number_of_locations'],
  enums: [
    { field: 'partner_type', options: PartnerBusinessTypeSchema.options },
    { field: 'legal_entity_type', options: LEGAL_ENTITY_TYPES }
  ],
  float: ['gratuity_percentage']
})

export const PartnerUpdate = (_context: NoContext = {}) =>
  z.preprocess(normalize, UpdatePartnerRequestSchema.strict())
